import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Pagination } from '@mui/material';
import axios from '../../shared/axiosConfig';
import AddIcon from '@mui/icons-material/Add';
import { Investor, InvestorPayouts, PaginatedResponse } from '../../shared/models';
import CurrencyAmount from '../../shared/components/CurrencyAmount';
import { SnackbarSeverity, useSnackbar } from '../../shared/services/SnackbarService';
import { useAuth } from '../../shared/context/AuthContext';
import DateTimeValue from '../../shared/components/DateTimeValue';
import InvestorPayoutsListDetail from './InvestorPayoutsListDetail';

const InvestorPayoutsList: React.FC = () => {
    const { userDetails } = useAuth();
    const [payouts, setPayouts] = useState<InvestorPayouts[]>([]);
    const [payoutsPaidAmount, setPayoutsPaidAmount] = useState<any>();
    const [search, setSearch] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(true);
    const { showSnackbar } = useSnackbar();
    const [page, setPage] = useState<number>(1);
    const [rowsPerPage] = useState<number>(9); // Number of restaurants per page
    const [totalPages, setTotalPages] = useState<number>();

    useEffect(() => {
        fetchPayouts();
        fetchPayoutsPaidAmount();
    }, []);

    

    const fetchPayouts = async () => {
        try {
            let url = 'investor-payouts/';
            setLoading(true);
            const response = await axios.get<PaginatedResponse<InvestorPayouts>>(url, {
                params: {
                    page: page,
                    page_size: rowsPerPage
                }
            });
            setPayouts(response.data.results);
            setTotalPages(Math.ceil(response.data.count/rowsPerPage));
        } catch (error) {
            console.error("Failed to fetch Payouts", error);
            showSnackbar("Failed to fetch Payouts. Please try again.", SnackbarSeverity.ERROR);
        } finally {
            setLoading(false);
        }
    };
    const fetchPayoutsPaidAmount = async () => {
        const response = await axios.get<any>('investor-payouts/paid_amount/');
        setPayoutsPaidAmount(response.data);
    };

    return (
        <div>
            <h2>My Payouts</h2>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div>
                    <h4>Total Paid - <CurrencyAmount amount={payoutsPaidAmount} /></h4>
                </div>
            </div>
                
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Business</TableCell>
                            <TableCell>Paid Amount</TableCell>
                            <TableCell>Paid Date</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payouts.map((payout, index) => (
                            // <TableRow key={payout.id}>
                            //     <TableCell>{index + 1}</TableCell>
                                
                            //     <TableCell>{payout.business.name}</TableCell>
                            //     <TableCell><CurrencyAmount amount={payout.payout_amount} /></TableCell>
                            //     <TableCell><DateTimeValue value={payout.payout_date}  /></TableCell>
                            // </TableRow>
                            <InvestorPayoutsListDetail row={payout} index={index} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    variant="outlined"
                    shape="rounded"
                    style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}

                />
        </div>
    );
};

export default InvestorPayoutsList;